
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Story } from '@/utils/storiesData';

interface EditorsPicksSectionProps {
  stories: Story[];
  menuItemText: string;
  menuText: string;
  menuHeaderText: string;
  borderColor: string;
}

const EditorsPicksSection: React.FC<EditorsPicksSectionProps> = ({
  stories,
  menuItemText,
  menuText,
  menuHeaderText,
  borderColor
}) => {
  const navigate = useNavigate();
  const editorsPicks = stories.filter(story => story.featured).slice(0, 2);

  return (
    <div className="space-y-6">
      <h3 className={`text-sm font-medium uppercase tracking-wider mb-3 ${menuHeaderText} font-chroma`}>
        EDITOR'S PICKS
      </h3>
      <div className="grid grid-cols-2 gap-6">
        {editorsPicks.map((story) => (
          <button
            key={story.id}
            onClick={() => navigate(`/stories/${story.slug}`)}
            className="group flex flex-col gap-4 text-left"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={story.coverImage}
                alt={story.title}
                className="w-full h-full object-cover transition-transform hover:scale-105 duration-300"
              />
            </div>
            <div className="flex-1">
              <h4 className={`text-sm font-medium group-hover:underline line-clamp-2 ${menuItemText}`}>
                {story.title}
              </h4>
              <p className={`text-sm mt-1 line-clamp-2 ${menuText}`}>
                {story.excerpt}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EditorsPicksSection;
